<div class="wrapper">
  <div class="layout">
    <div class="controls">
      <img (pointerup)="deviceSvc.hamburgerMenu = false"
           alt="close menu"
           src="assets/img/close.svg" />
    </div>
    <div class="menu-items">
      @for (item of menuItems; track item) {
        <app-menu-item-mobile
          [item]="item">
        </app-menu-item-mobile>
      }
    </div>
  </div>
</div>
